const InformationConfig = {
  collection: "information",
  single: true,
  fields: [
    "id",
    "support_authenticated",
    "support_unauthenticated",
    "epson_privacy_policy_url",
    "productbox_privacy_policy_url",
    "epson_privacy_policy_text",
    "productbox_privacy_policy_text",
    "get_support_text",
    "welcome_text",
    "footer_text_general",
    "footer_text_calculations",
    "login_disclaimer",
    "report_generation_disclaimer"
  ],

  adapter: class Information {
    constructor(info) {
      Object.assign(this, info);
    }
  }
};

export default InformationConfig;
